<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="isEditing ? '修改服務紀錄範本類別' : '新增服務紀錄範本類別'"></page-title>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-accent float-right" @click="removeRecordTemplateGroup">刪除服務紀錄範本類別</md-button>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised" @click="$router.back()">返回</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-primary float-right" @click="isEditing ? editRecordTemplateGroup() : createRecordTemplateGroup()">送出</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'

export default {
  data () {
    return {
      isEditing: null,
      data: {
        name: null
      }
    }
  },
  components: {
    PageTitle
  },
  created: function () {
    if (this.$route.params.id !== 'add') {
      this.isEditing = this.$route.params.id
    }
    if (this.isEditing) {
      this.readRecordTemplateGroup(this.isEditing)
    }
  },
  methods: {
    readRecordTemplateGroup: async function (groupID) {
      let req = await axios.get(urls({route: 'record-template-group', id: groupID}), this.data)
      this.data = req.data.data
    },
    editRecordTemplateGroup: async function () {
      let req = await axios.put(urls({route: 'record-template-group', id: this.isEditing}), this.data)
      if (req.status === 200) {
        this.$router.push('/record-template-group')
      }
    },
    createRecordTemplateGroup: async function () {
      let req = await axios.post(urls({route: 'record-template-group', id: this.isEditing}), this.data)
      if (req.status === 201) {
        this.$router.push('/record-template-group')
      }
    },
    removeRecordTemplateGroup: async function () {
      let req = await axios.delete(urls({route: 'record-template-group', id: this.isEditing}))
      if (req.status === 200) {
        this.$router.push('/record-template-group')
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/RecordTemplateGroup/RecordTemplateGroupEdit.vue